import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/_services/app.service';
import { CommonModalComponent } from '../../common/common-modal/common-modal.component';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { FormControl } from '@angular/forms';
import { fromEvent, Observable, pipe, Subject, Subscription } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { debounceTime, filter, map, startWith } from 'rxjs/operators';
export interface Fruit {
  name: string;
}
@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  @ViewChild('stepper') private myStepper: MatStepper;
  @ViewChild('myFileInput') myFileInput;
  Grouptt = ''

  item: any;
  modalGroup: any = {
    IsApproved: 1
  };
  Category: any = {
    IsApproved: 1
  };
  SubCategory: any = {
    IsApproved: 1

  };
  FileType: any = {
    IsApproved: 1
  };
  addDocument: any = {
    folderId: 1,
    ipAddress: "0.0.0.0",
    documentList: [],
    tagList: []
  }

  groupList: any[] = [];
  categoryList: any[] = [];
  addGroupList: any;
  subCategoryList: any;
  CategoryDropList: any;
  imgUploadJson: any = {};
  fileSizeError: any;
  minDate = new Date();
  editFileDoc: any;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  // fruits: Fruit[] = [{ name: 'Lemon' }, { name: 'Lime' }, { name: 'Apple' }];
  fileTypeNameLists: any[] = [];
  commentList: any[] = [];
  messageModal: any = {};
  docData: any;
  actList: any[] = [];

  // AutoComplete
  fruitCtrl = new FormControl('');
  filteredFruits: Observable<string[]>;
  emails: any[] = [];
  allFruits: any[] = [];
  allEmails: any[] = [];
  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  shareModel: any = {
    DocumentSharedWith: [],
    DocumentIds: [],
    ipaddress: '',
  };
  shareModelGroup: any = {
    SharedWithUserId: [],
    ipaddress: '',
  };
  imgProcessBar: any;
  obs: Subscription;
  userInform: any;
  getSharList: any;

  searchResults: string[];
  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private spinner: NgxSpinnerService
  ) {
    this.item = data;
    console.log(this.item);
    if (this.item.action == 'shareFile') {
      this.item.data.documentTypeExtension = this.item?.data?.documentTypeExtension?.toLowerCase();
      if (this.item?.pageName == 'groups') {
        this.getShare();
      }
    }

    this.fruitCtrl.valueChanges.pipe(debounceTime(500)).subscribe(value => {
      this.checkEmailName(value);
    });
  }

  ngOnInit(): void {

    if (this.item.action == 'addCategory' || this.item.action == 'addSubCategory' || this.item.action == 'editcategory' || this.item.action == 'editsubCategory') {
      this.appService.postService({}, 'Master/GroupDropDownList').subscribe(response => {
        this.groupList = response.body;
        console.log(this.groupList);
      })
    };

    this.appService.postService({}, 'Master/GroupDropDownList').subscribe(response => {
      this.addGroupList = response.body;
      console.log(this.groupList);
    })


    if (this.item.action == 'editGroup') {
      this.spinner.show();
      this.appService.postService(this.item.data, 'Master/GroupGetById').subscribe(response => {
        this.spinner.hide();
        this.modalGroup = response.body.result
        console.log(response);
        // this.modalGroup = this.item.data;

      })
    }

    if (this.item.action == 'editcategory') {
      this.spinner.show();
      this.appService.postService(this.item.data, 'Master/CategoryGetById').subscribe(response => {
        this.spinner.hide();
        this.Category = response.body.result
        console.log(response);


      })
    }
    if (this.item.action == 'editsubCategory') {
      this.spinner.show();

      this.appService.postService(this.item.data, 'Master/SubCategoryGetById').subscribe(response => {
        this.spinner.hide();
        this.SubCategory = response.body.result
        this.groupDropDown(this.SubCategory.groupId)
        console.log(response);
      })
    }
    if (this.item.action == 'editfileType') {
      this.FileType = this.item.data;
    }
    if (this.item.action == 'editFileDocument' || this.item.action == 'uploadNewVersion') {
      this.appService.postService({ documentId: this.item.data.documentId }, 'Document/Documentgetbyid').subscribe(res => {
        const data = res.body.result;
        this.addDocument.documentList = [
          {
            documentId: data?.documentId,
            documentName: data?.documentName,
            documentSize: data?.documentSize,
            documentType: data?.documentType,
            groupId: data?.groupId,
            categoryId: data?.categoryId,
            subCategoryId: data?.subCategoryId,
          }
        ];
        console.log(this.addDocument);

        // if (this.item.action == 'uploadNewVersion') {
        //   this.addDocument.documentList = [];
        // }
        // debugger
        this.groupDropDown(data?.groupId);
        this.CategoryDropDown(data?.categoryId)

      })
    }
    if (this.item.action == 'addFileType' || this.item.action == 'editfileType') {
      this.fileTypeNameList();
    }
    if (this.item.action == 'viewDoc') {
      this.getComment(this.item?.data?.documentId);
      this.getDocument(this.item?.data?.documentId);
      this.getActivity();
      this.userInfo();
    }
  }

  getShare() {
    this.appService.postService({ GroupId: this.item?.data?.groupId }, 'master/GroupPermissionById').subscribe(res => {
      if (res?.body?.sharedWithUser?.length > 0) {
        this.getSharList = res?.body?.sharedWithUser;
        this.emails = res?.body?.sharedWithUser;
      }
    })
  }
  shareallchange(event){
    console.log(event)
    this.emails = []
    this.shareModelGroup.SharedWithUserId = []
    this.shareModelGroup.IsShareWithEveryOne = event.checked;
    this.shareModel.SharedWithUserId = []
    this.shareModel.IsShareWithEveryOne = event.checked;
  }
  shareFileSubmit() {
    let payload;
    let apiName;
    console.log(this.emails);
    this.shareModel.DocumentSharedWith = this.emails.map(x => parseInt(x.userId));
    if (!this.shareModel.isPassword) {
      this.shareModel.documentpassword = '';
    }
    this.spinner.show();
    if (this.item?.pageName != 'groups') {
      if (this.item?.type == 'single') {
        this.shareModel.DocumentIds.push(this.item?.data?.documentId);
      } else {
        const a = this.item.data.filter(x => x.is_selected);
        this.shareModel.DocumentIds = a.map(x => x.documentId);
      }
      payload = this.shareModel;
      apiName = 'Document/DocumentShare';
    } else if (this.item?.pageName == 'groups') {
      this.shareModelGroup.SharedWithUserId = this.emails.map(x => parseInt(x.userId));
      this.shareModelGroup.GroupId = this.item?.data?.groupId;
      payload = this.shareModelGroup;
      apiName = 'master/GroupPermissionSave';
    }
    this.appService.postService(payload, apiName).subscribe(res => {
      console.log(res);
      this.spinner.hide();
      if (this.item?.pageName == 'groups') {
        if (res?.body?.transactionMessage?.success) {
          this.appService.alertPopup('success', res?.body?.transactionMessage?.message);
          this.dialogRef.close(payload)
        } else {
          this.appService.alertPopup('delete', res?.body?.transactionMessage?.message);
        }
      } else {
        if (res?.body?.result?.transactionMessage?.success) {
          this.appService.alertPopup('success', res?.body?.result?.transactionMessage?.message);
          this.dialogRef.close(payload)
        } else {
          this.appService.alertPopup('delete', res?.body?.result?.transactionMessage?.message);
        }
      }
    })
  }
  shareFile(data) {
    const dialogRef = this.dialog.open(DialogComponent, {
      panelClass: 'modal-width',
      autoFocus: false,
      data: { action: 'shareFile', data: data, type: 'single' }
    })
  }

  checkEmailName(e) {
    console.log(e)
    this.allFruits = [];
    let keyName;
    if (this.item?.pageName == 'groups') {
      keyName = 'p';
    } else {
      keyName = 's';
    }
        this.appService.postService({}, `Login/GetUserListForDocumentSharing?requestFrom=${keyName}&userName=` + e).subscribe(response => {
          this.allEmails = [];
          this.allEmails = response.body.result;
          for (let list of this.allEmails) {
            this.allFruits.push(list.userEmail)
          }
          console.log(this.allEmails);
          this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
            startWith(null),
            map((fruit: string | null) => (fruit ? this._filter(fruit) : this.allFruits.slice())),
          );
        })
  }

  removeShareChip(fruit: string): void {
    const index = this.emails.indexOf(fruit);

    if (index >= 0) {
      this.emails.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(event);
    const data = this.allEmails.filter(x => x.userEmail == event.option.viewValue)[0];
    console.log(data);

    this.emails.push(data);
    console.log(this.emails);

    this.fruitInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);

    //

    /* if (!this.emails.includes(event.option.value)) {
      this.emails.push(event.option.value);
    } */

    this.fruitInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    console.log(value);

    const filterValue = value.toLowerCase();
    console.log(filterValue);
    console.log(this.allFruits);


    return this.allFruits.filter(fruit => fruit.toLowerCase().includes(filterValue) === 0);

  }




  getActivity() {
    this.spinner.show();
    const payload = {
      start: 0,
      length: 100,
      documentid: this.item?.data?.documentId
    }
    this.appService.postService(payload, 'Document/ActivityList').subscribe(response => {
      this.spinner.hide();
      this.actList = response.body.activityList;
      console.log(response);
    })
  }

  getComment(id) {
    this.appService.postService({ documentid: id }, 'Document/CommentListForDocument').subscribe(res => {
      if (res.body.success) {
        this.commentList = res.body.records;
      }
    })
  }
  getDocument(id) {
    this.spinner.show();
    this.appService.postService({ documentid: id }, 'Document/DocumentGetById ').subscribe(res => {
      this.spinner.hide();
      if (res.body.success) {
        this.docData = res.body.result;

        let exe = this.docData?.documentTypeExtension.toLowerCase();
        let baseType;
        if (exe == 'png' || exe == 'jpg') {
          baseType = 'image';
        } else if (exe == 'pdf') {
          baseType = 'application';
        }
        else if (exe == 'docx') {
          baseType = 'application';
          exe = 'vnd.openxmlformats-officedocument.wordprocessingml.document';
        }
        else if (exe == 'xlsx') {
          baseType = 'application';
          exe = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        } else {
          baseType = 'application/octet-stream';
        }
        console.log(exe);


        this.docData.documentData = `data:${baseType}/${exe};base64,${this.docData.documentData}`;
        console.log(this.docData.documentData);

        this.docData.documentTypeExtension = this.docData.documentTypeExtension.toLowerCase();
        this.getActivity();
        this.item.data.documentId = id;
      }
    })
  }
  messageSubmit() {
    this.spinner.show();
    this.messageModal.documentid = this.item?.data?.documentId;
    this.appService.postService(this.messageModal, 'Document/AddDocumentComment').subscribe(res => {
      this.spinner.hide();
      if (res.body.success) {
        this.getComment(this.item?.data?.documentId);
        this.messageModal = {};
      }
    })
  }

  fileTypeNameList() {
    this.appService.postService({}, 'Master/Filetypenamelist').subscribe(res => {
      console.log(res);
      this.fileTypeNameLists = res.body.records;
    })
  }
  groupDropDown(id) {
    if (id) {
      this.spinner.show();
      this.appService.postService({}, 'Master/categoryDropDownList?groupid=' + id).subscribe(response => {
        this.spinner.hide();
        this.CategoryDropList = response.body
        console.log(this.CategoryDropList);
      })
    }
  }
  CategoryDropDown(id) {
    if (id) {
      this.spinner.show();
      this.appService.postService({}, 'Master/SubCategoryDropDownList?categoryId=' + id).subscribe(response => {
        this.spinner.hide();
        this.subCategoryList = response.body
        console.log(this.subCategoryList);

      })
    }

  }

  onSubmitGroup() {
    this.spinner.show();
    this.appService.postService(this.modalGroup, 'Master/GroupSave').subscribe(response => {
      this.spinner.hide();
      if (response.body.success) {
        this.dialogRef.close({ data: Object.assign(this.modalGroup) });
        const dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'success', statusText: response.body.result.transactionMessage.message }
        });
      } else {
        const dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: response.body.result.transactionMessage.message }
        });
      }
    },
      err => {
        this.dialogRef.close()
      })
  }

  onSubmitCategory() {
    this.spinner.show();
    this.appService.postService(this.Category, 'Master/CategorySave').subscribe(response => {
      console.log(response);
      this.spinner.hide();
      if (response.body.success) {
        this.dialogRef.close({ data: Object.assign(this.Category) });
        const dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'success', statusText: response.body.result.transactionMessage.message }
        });
      } else {
        const dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: response.body.result.transactionMessage.message }
        });
      }
    });
  }
  onSubmitSubCategory() {
    this.spinner.show();
    this.appService.postService(this.SubCategory, 'Master/SubCategorySave').subscribe(response => {
      console.log(response);
      this.spinner.hide();
      if (response.body.success) {
        this.dialogRef.close({ data: Object.assign(this.SubCategory) });
        const dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'success', statusText: response.body.result.transactionMessage.message }
        });
      } else {
        const dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: response.body.result.transactionMessage.message }
        });
      }
    });
  }

  onSubmitFileType() {
    this.spinner.show();
    this.appService.postService(this.FileType, 'Master/FileTypeSave').subscribe(response => {
      this.spinner.hide();
      if (response.body.success) {
        this.dialogRef.close({ data: Object.assign(this.FileType) });
        const dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'success', statusText: response.body.result.transactionMessage.message }
        });
      } else {
        const dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: response.body.result.transactionMessage.message }
        });
      }
    },
      err => {
        this.dialogRef.close()
      })
  }

  fileUpload(event, data, arrayName) {
    data = {}

    this.appService.imageUpload(event, data).subscribe(res => {
      console.log(res);
      if (res.errorText == '') {
        this.imgProcessBar = res;
        if (res.percentDone == 100) {
          this.fileSizeError = '';
          arrayName.push(res);
          console.log(arrayName);

          // arrayName.forEach(element => {
          //   element.documentName = res.DocumentFileName
          //   element.documentData = res.FileData
          //   element.documenttype = res.FileExe
          //   element.documentsize = (res.documentsize * 1024).toString()

          // });
        }
      }
      /* this.appService.postService(res.documenttype, 'Master/FileSizeCheck').subscribe(response => {
        console.log(response);
 
        
        } else {
          this.fileSizeError = res.errorText;
        }
 
      }) */
    });
  }
  fileUploadRemove(data, list) {

    let index = data.documentList.findIndex(x => x.documentName == list.documentName);
    if (index > -1) {
      data.documentList.splice(index, 1)
    }
    console.log(index);
    // data.DocumentFileName = '';
    // data.FileData = '';
    // data.DocumentId = 0
    // data.FileExe = ''
    // data.documentsize = '';
    //  data.FileExe = '';
    // this.myFileInput.nativeElement.value = '';
    // this.myFileInput7.nativeElement.value = '';
  }

  downloadMyFile(data) {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    console.log(data);

    if (data.FileData) {
      link.setAttribute('href', data.Preview);
    } else {

      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', data.DocumentPath);
      link.setAttribute('download', data.DocumentFileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

    }

    console.log(link);
    link.setAttribute('download', data.DocumentFileName);
    document.body.appendChild(link)
    link.click();
    link.remove();
  }

  onSubmitAddFileDoc(d, docName) {
    let apiUrl

    if (this.item.action == 'addFileDocument') {
      apiUrl = 'Document/DocumentSaveFromDMS'
      if (this.addDocument?.documentList?.length > 0) {
        for (let list of this.addDocument?.documentList) {
          list.documentRemarks = this.addDocument?.documentRemarks;
          list.groupId = this.item?.data?.group?.groupId;
          list.categoryId = this.item?.data?.category?.categoryId;
          list.subCategoryId = this.item?.data?.subCategory?.subCategoryId;
        }
      }
    }
    if (this.item.action == 'editFileDocument') {
      apiUrl = 'Document/DocumentUpdate';
    }
    if (this.item.action == 'uploadNewVersion') {
      apiUrl = 'Document/DocumentSaveNewVersion'
    }
    if (this.addDocument?.documentList?.length > 0) {
      this.spinner.show();
      this.appService.postService({ DocumentName: docName }, 'document/DocumentIsExists').subscribe(res => {
        this.spinner.hide();
        if (res?.body?.result) {
          this.appService.alertPopup('Alert', 'Same file already exists!');
          this.addDocument?.documentList.pop();
        } else {
          this.spinner.show();
          this.appService.postService(this.addDocument, apiUrl).subscribe(response => {
            console.log(response);
            this.spinner.hide();
            if (response.body.success) {
              this.dialogRef.close({ data: Object.assign(this.addDocument) });
              const dialogRef = this.dialog.open(CommonModalComponent, {
                width: '300px',
                disableClose: true,
                autoFocus: false,
                panelClass: 'statusClass',
                data: { action: 'success', statusText: response.body.result.transactionMessage.message }
              });
            } else {
              const dialogRef = this.dialog.open(CommonModalComponent, {
                width: '300px',
                disableClose: true,
                autoFocus: false,
                panelClass: 'statusClass',
                data: { action: 'delete', statusText: response?.body?.result?.transactionMessage?.message }
              });
            }
          });
        }
      })
    }
  }
  compareFn(a: any, b: any) {
    if (b) {
      const d = a[Object.keys(a)[0]];
      const e = b[Object.keys(b)[0]];
      return d === e;
    }
  }
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    const input = event.input;

    // Add our fruit
    if ((value || '').trim()) {
      this.addDocument.tagList.push({ tagName: value.trim(), tagId: 0 });
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }

    // Clear the input value
    event.chipInput!.clear();
  }

  remove(fruit: Fruit): void {
    const index = this.addDocument.tagList.indexOf(fruit);

    if (index >= 0) {
      this.addDocument.tagList.splice(index, 1);
    }
  }
  deleteComment(id) {
    const dialogRef = this.dialog.open(CommonModalComponent, {
      width: '300px',
      disableClose: true,
      autoFocus: false,
      panelClass: 'statusClass',
      data: { action: 'delete', statusText: 'Are you sure you want to delete record' }
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.spinner.show();
        this.appService.postService({ commentId: id }, 'Document/RemoveDocumentComment').subscribe(response => {
          this.spinner.hide();
          if (response.body.success) {
            this.getComment(this.item?.data?.documentId);
            this.appService.alertPopup('success', response.body.result.transactionMessage.message);
          } else {
            this.appService.alertPopup('delete', response.body.result.transactionMessage.message);
          }
        })
      }
    })
  }
  deleteDoc(data) {
    const dialogRef = this.dialog.open(CommonModalComponent, {
      width: '300px',
      disableClose: true,
      autoFocus: false,
      panelClass: 'statusClass',
      data: { action: 'delete', statusText: 'Are you sure you want to delete record' }
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.appService.postService({ DocumentIds: [data?.documentId] }, 'Document/DocumentDelete').subscribe(response => {
          if (response.body.success) {
            $('#table1').DataTable().ajax.reload();
            this.appService.alertPopup('success', response.body.result.transactionMessage.message);
            this.dialogRef.close(data)
          } else {
            this.appService.alertPopup('delete', response.body.result.transactionMessage.message);
          }
        })
      }
    });
  }
  stopSharing(id) {
    const dialogRef = this.dialog.open(CommonModalComponent, {
      width: '300px',
      disableClose: true,
      autoFocus: false,
      panelClass: 'statusClass',
      data: { action: 'delete', statusText: 'Are you sure you want to stop sharing' }
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        const payload = {
          documentid: this.item?.data?.documentId,
          documentSharingId: id,
          ipaddress: '',
        }
        this.appService.postService(payload, 'document/DocumentStopShare').subscribe(res => {
          console.log(res);
          this.spinner.hide();
          if (res?.body?.result?.transactionMessage?.success) {
            this.appService.alertPopup('success', res?.body?.result?.transactionMessage?.message);
            this.dialogRef.close(payload)
          } else {
            this.appService.alertPopup('delete', res?.body?.result?.transactionMessage?.message);
          }
        })
      }
    })
  }
  userInfo() {
    this.appService.postService({}, 'login/GetUserInfo').subscribe(response => {
      this.userInform = response.body.result
      console.log(this.userInform);
    })
  }
  ngOnDestroy() {
    this.obs?.unsubscribe();
  }
}
